 
 <template>
  <div>
    <div class="d-sm-down-none m-0 mt-5">
      <CCard class="custom-menu">
        <CCol sm="12">
          <CRow>
            <CCol sm="3" @click="GoToDashBoard()">
              <CIcon
                style="color: darkcyan"
                name="cil-list-rich"
                width="25px"
                title="Daily Quiz"
              />
              <div style="color: #000" title="Daily Quiz">Quiz</div>
            </CCol>
            <CCol sm="3" @click="GoToStatistic()">
              <CIcon
                style="color: darkcyan"
                name="cil-clipboard"
                width="25px"
                title="Daily Quiz"
              />
              <div style="color: #000" title="Daily Quiz">Compete</div>
            </CCol>
            <CCol sm="3" @click="GoToScore()">
              <CIcon
                style="color: darkcyan"
                name="cil-chart"
                width="25px"
                title="Daily Quiz"
              />
              <div style="color: #000" title="Daily Quiz">Score</div>
            </CCol>
            <CCol sm="3" @click="GoToAccount()">
              <CIcon
                style="color: darkcyan"
                name="cil-user"
                width="25px"
                title="Daily Quiz"
              />
              <div style="color: #000" title="Daily Quiz">Account</div>
            </CCol>





            
          </CRow>
        </CCol>
      </CCard>


     

    </div>


     <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 80px;
        z-index: 1;
        right:1px
      "
    class="d-md-none d-lg-none">
      <CRow class="justify-content-center">
        <CCol
          style="display: flex; align-items: center; justify-content: center"
          align="center"
        >
          <CCol sm="12" lg="12"><br />
            <CCard class="p-1 box-shadow">
              <CCol
                sm="12"
                lg="12"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <CCol
                  sm="3"
                  lg="3"
                  @click="GoToDashBoard()"
                  class="p-0 m-0"
                  style="flex: 1"
                >
                    <CIcon
                      style="color: darkcyan"
                      name="cil-list-rich"
                      width="25px"
                      title="Daily Quiz"
                    />
                    <div style="color:#000" title="Daily Quiz">Quiz</div>
                </CCol>

                <CCol
                  sm="3"
                  lg="3"
                  @click="GoToStatistic()"
                  class="p-0 m-0"
                  style="flex: 1"
                >
                    <CIcon
                      style="color: darkcyan"
                      name="cil-clipboard"
                      width="25px"
                    />
                    <!-- <img src="../assets/img/icontest.png" width="30px" /> -->
                    <div style="color:#000">Compete</div>
                </CCol>

                <CCol
                  sm="3"
                  lg="3"
                  @click="GoToScore()"
                  class="p-0 m-0"
                  style="flex: 1"
                >
                    <CIcon
                      style="color: darkcyan"
                      name="cil-chart"
                      width="25px"
                      title="Score Card"
                    />
                    <!-- <img src="../assets/img/iconscorerate.png" width="30px" /> -->
                    <div style="color:#000" title="Score Card">Score</div>
                </CCol>

                <CCol
                  sm="3"
                  lg="3"
                  @click="GoToAccount()"
                  class="p-0 m-0"
                  style="flex: 1"
                >
                    <CIcon
                      style="color: darkcyan"
                      name="cil-user"
                      width="25px"
                      title="My Account"
                    />
                    <!-- <img src="../assets/img/usernobg.png" width="30px" /> -->
                    <div style="color:#000" title="My Account">
                      Account
                    </div>
                </CCol>
                
              </CCol>
            </CCard>
          </CCol>
        </CCol>
      </CRow>
    </div>

    
  </div>
</template>
 
  


    
<script>
import Vue from "vue";
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import backgroundUrl from "../assets/img/bgtips.png";

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";

Vue.use(FullCalendar);
Vue.use(VueEllipseProgress);

export default {
  name: "Collapses",
  components: {
    PulseLoader,
    CChartBar,
    Calendar,
  },
  data() {
    return {
      backgroundUrl,
      user: {},
      studentProfile: {},
      news: [],
      student: [],
      childs: [],
      studentProfileAuthorize: "",
    };
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetUserProfile();
      this.GetListChild();
      this.GetAuthorizeProfile();
    } else {
      this.GoToLogin();
    }
  },
  computed: {},

  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            console.log(":testing" + this.user.id);
            this.GetAuthorizeProfile(this.user.id);
            this.GetListChild(this.user.id);
            this.GetUserProfile(this.user.id);
          }
        });
    },
    GetUserProfile() {
      this.$API
        .get(this.$ParentProfile + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentProfile = response.data;
          }
        });
    },

    GetListChild() {
      this.$API
        .get(this.$StudentListAuthorize + "?id=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.childs = response.data;
            this.getPicChild(this.childs);
          }
        });
    },
    GetAuthorizeProfile() {
      this.$API
        .get(this.$GetProfilePhotoAuthorize + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentProfileAuthorize = response.data;
            this.photoURL =
              "https://pickiddo.com" + this.studentProfileAuthorize;
          }
        });
    },
    GoToDashBoard() {
      this.$router.push(
        "/QuizStudentDashboard?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId
      );
    },
    GoToStatistic() {
      this.$router.push(
        "/QuizStudentExam?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId
      );
    },
    GoToScore() {
      this.$router.push(
        "/QuizStudentOverview?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId
      );
    },
    GoToAccount() {
      this.$router.push(
        "/QuizStudentProfile?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId
      );
    },
    EShop() {
      this.$router.push(
        "/QuizStudentSubscription?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId
      );
    },
  },
};
</script>

<style scoped>
#wrapper { width: 300px; background: orange; margin: 0 auto; position: relative; }
#feedback { position: fixed; right: 0; top: 120px; }
</style>
    